"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import { useLegalNoticeData } from "../../hooks/useLegalNoticeData";

const PrivacyContent = () => {
  const { data } = useLegalNoticeData();
  const t = useTranslations();

  const breadcrumbs = [
    { title: t("home"), url: "/" },
    { title: t("legalNotice.title"), url: "/legal-notice" },
  ];

  return (
    <Container className={S.wrapper}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <h1 className={S.title}>{t("legalNotice.title")}</h1>
      <div className={S.infoWrapper}>
        <div className={S.column}>
          <h4 className={S.columnTitle}>{t("legalNotice.address")}:</h4>
          <p className={clsx(S.columnText, S["columnText--uppercase"])}>{data?.address_block.name}</p>
          <p className={S.columnText}>{data?.address_block.address}</p>
        </div>
        <div className={S.column}>
          <h4 className={S.columnTitle}>{t("legalNotice.regData")}:</h4>
          <p className={S.columnText}>
            {t("legalNotice.regDepartment")}: {data?.registration_block.registration_number}
          </p>
          <p className={S.columnText}>
            {t("legalNotice.regNumber")}: {data?.registration_block.fiscal_code}
          </p>
          <p className={S.columnText}>
            {t("legalNotice.id")}: {data?.registration_block.ust_id}
          </p>
        </div>
        <div className={S.column}>
          <h4 className={S.columnTitle}>{t("legalNotice.manager")}:</h4>
          <p className={S.columnText}>{data?.manager_block.name}</p>
          <p className={clsx(S.columnText, S["columnText--opacity"])}>
            {t("legalNotice.tel")}: {data?.manager_block.phone}
          </p>
          <p className={clsx(S.columnText, S["columnText--opacity"])}>
            {t("legalNotice.fax")}: {data?.manager_block.fax}
          </p>
        </div>
      </div>
    </Container>
  );
};

export default PrivacyContent;
